import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5ea334c4"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "messenger__inner-body" };
const _hoisted_2 = { class: "messenger__inner-container" };
const _hoisted_3 = { class: "messenger__page" };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = { class: "card__header" };
const _hoisted_6 = { class: "card__header-title" };
const _hoisted_7 = { key: 1 };
const _hoisted_8 = { class: "card__header" };
const _hoisted_9 = { class: "card__header-title" };
const _hoisted_10 = { class: "avatar__stack" };
const _hoisted_11 = { class: "avatar__stack-item" };
const _hoisted_12 = { key: 0 };
const _hoisted_13 = { class: "messenger__selection--hover cursor-pointer card__table-wrapper" };
const _hoisted_14 = { key: 1 };
const _hoisted_15 = { key: 2 };
const _hoisted_16 = { class: "card__header" };
const _hoisted_17 = { class: "card__header-title" };
const _hoisted_18 = { key: 3 };
const _hoisted_19 = { key: 4 };
const _hoisted_20 = { class: "card__inner" };
const _hoisted_21 = { class: "text-align-center" };
const _hoisted_22 = { key: 5 };
const _hoisted_23 = { class: "card__inner" };
const _hoisted_24 = { class: "text-align-center" };
const _hoisted_25 = { key: 6 };
const _hoisted_26 = { class: "card__inner" };
const _hoisted_27 = { key: 7 };
const _hoisted_28 = { class: "card__header" };
const _hoisted_29 = { class: "card__header-title" };
const _hoisted_30 = { class: "card__inner--paddingless" };
const _hoisted_31 = { key: 8 };
const _hoisted_32 = { class: "card__header" };
const _hoisted_33 = { class: "card__header-title" };
const _hoisted_34 = { key: 9 };
const _hoisted_35 = { class: "card__header" };
const _hoisted_36 = { class: "card__header-title" };
import ArticleItem from '@/components/ArticleItem.vue';
import ConversationList from '@/components/ConversationList.vue';
import CoreService from "@/services/core.service";
import SearchInputField from "@/components/SearchInputField.vue";
import ContactChannelsCard from "@/components/cards/ContactChannelsCard.vue";
import MailFormCard from "@/components/cards/MailFormCard.vue";
import WhatsappCard from "@/components/cards/WhatsappCard.vue";
import WhatsappContactFormCard from "@/components/cards/WhatsappContactFormCard.vue";
import PageService from "@/services/page.service";
// import {useConfigStore} from "@/stores/config";
import { useStatusStore } from "@/stores/status";
import { Mail, Search, Send, MessageSquare } from 'lucide-vue-next';
import { useConversationStore } from "@/stores/conversation";
import { useNavigationStore } from "@/stores/navigation";
import { Views } from "@/types/ConfigTypes";
import { CardItemType } from '@/types/CardTypes';
import { t } from "@/utils/lang.util";
import { onMounted, onUnmounted, ref } from "vue";
import { useRoute } from "vue-router";
import ParentService from "@/services/parent.service";
import { MessengerHeight } from "@/types/Messenger";
import ConversationService from "@/services/conversation.service";
// const configStore = useConfigStore()
export default /*#__PURE__*/ _defineComponent({
    __name: 'Page',
    setup(__props) {
        const conversationStore = useConversationStore();
        const navStore = useNavigationStore();
        const statusStore = useStatusStore();
        const data = ref({});
        const id = ref(null);
        const fetchedData = ref({});
        const route = useRoute();
        const fetchData = async () => {
            const response = await PageService.get(id.value);
            data.value = response.data;
            fetchedData.value = true;
        };
        const startNewConversation = () => CoreService.push(Views.CONVERSATION);
        const openMailForm = () => CoreService.push(Views.MAILFORM);
        const agentAvailabilityClicked = () => ConversationService.openLastOrStartNewConversation();
        const conversationClicked = (id) => CoreService.push(Views.CONVERSATION, { id: id });
        const searchIconClicked = () => CoreService.push(Views.HELPCENTER);
        const calcAnimationDelay = (index) => {
            return '' + (0.1 * (index + 1)) + 's';
        };
        onUnmounted(() => {
            navStore.setNavHeaderTitle('');
            navStore.setNavHeaderText('');
        });
        onMounted(async () => {
            ParentService.setMessengerHeight(MessengerHeight.NORMAL);
            id.value = route.params.id;
            document.getElementsByClassName('header__page-view')[0]['style'].opacity = 1;
            await fetchData();
            navStore.setNavHeaderTitle(data.value['title']);
            navStore.setNavHeaderText(data.value['text']);
        });
        return (_ctx, _cache) => {
            const _component_BaseAvatar = _resolveComponent("BaseAvatar");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.cards, (card, index) => {
                            return (_openBlock(), _createElementBlock("div", { key: card }, [
                                (card.type === _unref(CardItemType).MAIL_FORM)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                        _withDirectives(_createElementVNode("div", {
                                            class: "card",
                                            style: _normalizeStyle({ 'animation-delay': calcAnimationDelay(index) })
                                        }, [
                                            _withDirectives(_createElementVNode("div", _hoisted_5, [
                                                _createElementVNode("div", _hoisted_6, _toDisplayString(card.header || _unref(t)('forms.types.EMAIL.header')), 1)
                                            ], 512), [
                                                [_vShow, card.header || _unref(t)('mailform.header')]
                                            ]),
                                            _createVNode(MailFormCard, {
                                                "no-focus": true,
                                                onSuccess: ($event) => (card.hide = true)
                                            }, null, 8, ["onSuccess"])
                                        ], 4), [
                                            [_vShow, !card.hide]
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                (card.type === _unref(CardItemType).AGENT_AVAILABILITY && ((_unref(statusStore).agentsOnline && _unref(t)('agents.availability.online')) ||
                                    (!_unref(statusStore).agentsOnline && _unref(t)('agents.availability.offline'))))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                        _createElementVNode("div", {
                                            class: "card",
                                            style: _normalizeStyle({ 'animation-delay': calcAnimationDelay(index) })
                                        }, [
                                            _createTextVNode(_toDisplayString(card.header) + " ", 1),
                                            _withDirectives(_createElementVNode("div", _hoisted_8, [
                                                _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('agents.header')), 1)
                                            ], 512), [
                                                [_vShow, _unref(t)('agents.header')]
                                            ]),
                                            _createElementVNode("div", {
                                                class: "card__inner messenger__selection--hover cursor-pointer",
                                                onClick: agentAvailabilityClicked
                                            }, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(statusStore).agents, (agent) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        key: agent,
                                                        style: { "display": "inline-block" }
                                                    }, [
                                                        _createElementVNode("div", _hoisted_10, [
                                                            _createElementVNode("div", _hoisted_11, [
                                                                _createVNode(_component_BaseAvatar, {
                                                                    name: agent.nick || agent.name,
                                                                    url: agent.avatarUrl,
                                                                    active: agent.status === 'ONLINE'
                                                                }, null, 8, ["name", "url", "active"])
                                                            ])
                                                        ])
                                                    ]));
                                                }), 128)),
                                                (_unref(statusStore).agentsOnline)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                                        _createElementVNode("div", _hoisted_13, [
                                                            _createElementVNode("div", null, [
                                                                _createVNode(_unref(MessageSquare), { color: "var(--link-color)" })
                                                            ]),
                                                            _createElementVNode("div", null, _toDisplayString(_unref(t)('agents.availability.online')), 1)
                                                        ])
                                                    ]))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_unref(t)('agents.availability.offline')), 1))
                                            ])
                                        ], 4)
                                    ]))
                                    : _createCommentVNode("", true),
                                (card.type === _unref(CardItemType).CHANNEL_SELECTOR)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                        _createElementVNode("div", {
                                            class: "card",
                                            style: _normalizeStyle({ 'animation-delay': calcAnimationDelay(index) })
                                        }, [
                                            _withDirectives(_createElementVNode("div", _hoisted_16, [
                                                _createElementVNode("div", _hoisted_17, _toDisplayString(card.header || _unref(t)('channels.header')), 1)
                                            ], 512), [
                                                [_vShow, card.header || _unref(t)('channels.header')]
                                            ]),
                                            _createVNode(ContactChannelsCard, {
                                                channels: card.data.channels
                                            }, null, 8, ["channels"])
                                        ], 4)
                                    ]))
                                    : _createCommentVNode("", true),
                                (card.type === _unref(CardItemType).CONVERSATION_LIST)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                        _createElementVNode("div", {
                                            class: "card",
                                            style: _normalizeStyle({ 'animation-delay': calcAnimationDelay(index) })
                                        }, [
                                            _createVNode(ConversationList, { onClicked: conversationClicked })
                                        ], 4)
                                    ]))
                                    : (card.type === _unref(CardItemType).START_NEW_CONVERSATION && _unref(conversationStore).canStartNewConversation)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                            _createElementVNode("div", {
                                                class: "card",
                                                style: _normalizeStyle({ 'animation-delay': calcAnimationDelay(index) })
                                            }, [
                                                _createElementVNode("div", _hoisted_20, [
                                                    _createElementVNode("div", _hoisted_21, [
                                                        _createElementVNode("button", {
                                                            onClick: startNewConversation,
                                                            class: "btn__primary"
                                                        }, [
                                                            _createVNode(_unref(Send), {
                                                                size: "18",
                                                                class: "btn__icon"
                                                            }),
                                                            _createTextVNode(" " + _toDisplayString(_unref(t)('common.buttons.start_new_conversation')), 1)
                                                        ])
                                                    ])
                                                ])
                                            ], 4)
                                        ]))
                                        : (card.type === _unref(CardItemType).SEND_EMAIL_BUTTON)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                                _createElementVNode("div", {
                                                    class: "card",
                                                    style: _normalizeStyle({ 'animation-delay': calcAnimationDelay(index) })
                                                }, [
                                                    _createElementVNode("div", _hoisted_23, [
                                                        _createElementVNode("div", _hoisted_24, [
                                                            _createElementVNode("button", {
                                                                onClick: openMailForm,
                                                                class: "btn__primary"
                                                            }, [
                                                                _createVNode(_unref(Mail), {
                                                                    size: "18",
                                                                    class: "btn__icon"
                                                                }),
                                                                _createTextVNode(" " + _toDisplayString(_unref(t)('common.buttons.go_to_mailform')), 1)
                                                            ])
                                                        ])
                                                    ])
                                                ], 4)
                                            ]))
                                            : (card.type === _unref(CardItemType).HELP_CENTER_SEARCH_BAR)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                                    _createElementVNode("div", {
                                                        class: "card",
                                                        style: _normalizeStyle({ 'animation-delay': calcAnimationDelay(index) })
                                                    }, [
                                                        _createElementVNode("div", _hoisted_26, [
                                                            _createVNode(SearchInputField, { pushNavigation: true })
                                                        ])
                                                    ], 4)
                                                ]))
                                                : (card.type === _unref(CardItemType).ARTICLE_LIST)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                                        _createElementVNode("div", {
                                                            class: "card",
                                                            style: _normalizeStyle({ 'animation-delay': calcAnimationDelay(index) })
                                                        }, [
                                                            _createElementVNode("div", _hoisted_28, [
                                                                _createElementVNode("div", _hoisted_29, _toDisplayString(card.header), 1),
                                                                _createElementVNode("div", {
                                                                    class: "card__header-option cursor-pointer",
                                                                    onClick: searchIconClicked
                                                                }, [
                                                                    _createVNode(_unref(Search), { size: "16" })
                                                                ])
                                                            ]),
                                                            _createElementVNode("div", _hoisted_30, [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(card.data.articles, (item) => {
                                                                    return (_openBlock(), _createBlock(ArticleItem, {
                                                                        key: item.id,
                                                                        id: item.id,
                                                                        title: item.title,
                                                                        body: item.excerpt
                                                                    }, null, 8, ["id", "title", "body"]));
                                                                }), 128))
                                                            ])
                                                        ], 4)
                                                    ]))
                                                    : (card.type === _unref(CardItemType).WHATSAPP_CONNECT && card.data.phone)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                                            _createElementVNode("div", {
                                                                class: "card",
                                                                style: _normalizeStyle({ 'animation-delay': calcAnimationDelay(index) })
                                                            }, [
                                                                _withDirectives(_createElementVNode("div", _hoisted_32, [
                                                                    _createElementVNode("div", _hoisted_33, _toDisplayString(card.header || _unref(t)('channels.whatsapp.card_header')), 1)
                                                                ], 512), [
                                                                    [_vShow, card.header || _unref(t)('channels.whatsapp.card_header')]
                                                                ]),
                                                                _createVNode(WhatsappCard, {
                                                                    phone: card.data.phone
                                                                }, null, 8, ["phone"])
                                                            ], 4)
                                                        ]))
                                                        : (card.type === _unref(CardItemType).WHATSAPP_CONTACT_FORM)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                                                _createElementVNode("div", {
                                                                    class: "card",
                                                                    style: _normalizeStyle({ 'animation-delay': calcAnimationDelay(index) })
                                                                }, [
                                                                    _withDirectives(_createElementVNode("div", _hoisted_35, [
                                                                        _createElementVNode("div", _hoisted_36, _toDisplayString(card.header || _unref(t)('channels.whatsapp.card_header')), 1)
                                                                    ], 512), [
                                                                        [_vShow, card.header || _unref(t)('channels.whatsapp.card_header')]
                                                                    ]),
                                                                    _createVNode(WhatsappContactFormCard)
                                                                ], 4)
                                                            ]))
                                                            : _createCommentVNode("", true)
                            ]));
                        }), 128))
                    ])
                ])
            ]));
        };
    }
});
